import { Alert, Box, Button, Chip, Stack, Typography } from '@mui/joy';
import useGCoinRead from '../../hooks/useGCoinRead';
import { gcoinDate } from '../../gcoinApi';
import { cardSx, LoadState } from './GCoinUI';

export default function GCoinPushStatus() {
    const resource = useGCoinRead('notifications/status/', { poll: true });
    const data = resource.data;
    return <Box sx={cardSx}>
        <Typography sx={{ fontWeight: 800 }}>Доставка уведомлений G coin</Typography>
        <LoadState error={resource.error} loading={resource.loading} empty={!data} />
        {data && <Stack spacing={1} sx={{ mt: 1.5 }}>
            <Chip size="sm" color={data.worker_online ? 'success' : 'warning'}>{data.worker_online ? 'Обработчик на связи' : 'Нет свежего ответа обработчика'}</Chip>
            <Typography level="body-xs">Последний запуск: {gcoinDate(data.seen_at)} МСК</Typography>
            {data.configuration_error && <Alert color="warning">{data.configuration_error}</Alert>}
            <Typography level="body-sm">Сообщений к подготовке: {data.waiting_messages}</Typography>
            <Typography level="body-sm">Устройств в очереди: {(data.deliveries.pending || 0)+(data.deliveries.sending || 0)} · Принято push-сервисом: {data.deliveries.sent || 0}</Typography>
            <Typography level="body-sm">Пропущено: {data.deliveries.skipped || 0} · Попытки исчерпаны: {data.deliveries.failed || 0}</Typography>
            {!!data.deliveries.failed && <Alert color="warning">Есть недоставленные push. Сообщения сохранены в личных уведомлениях сотрудников; подробности доступны в серверном журнале доставки.</Alert>}
            <Typography level="body-xs">Успех отправки не означает, что человек увидел уведомление. Отключённые push не влияют на начисления и личную историю.</Typography>
        </Stack>}
        <Button variant="plain" loading={resource.loading} onClick={resource.refresh} sx={{ mt: 1 }}>Обновить доставку</Button>
    </Box>;
}